module.exports = __webpack_public_path__ + "static/media/img-home8.1e905656.jpg";